module.exports = __webpack_public_path__ + "static/media/Lanturn_gaussian2.c7020ce5.png";